export const error = {
  en: {
    "error.email_format": "* Invalid email format",
    "error.invalid_code": "*Invalid code. Please try again",
    "error.invalid_code_format": "* Invalid code format",
    "error.pass_required": "*Password required",
    "error.incorrect_email": "Incorrect email address",
    "error.invalid": "Incorrect email address",
    "error.pass_different": "*Passwords do not match",
    "error.max": "*The amount exceeds the allowed limit",
    "error.min": "*The amount is too low",
    "error.file_too_large": "File size must be less than 2MB",
    "error.avatar_too_large_hint":
      "Image is too large. Please upload a smaller file (for example, up to 1–2MB).",
    "error.invalid_file_type": "Please select an image file",
    "error.upload_failed": "Failed to upload avatar",
    "error.select_payment_method": "* Select a payment method",
    "common.error_occurred": "An error occurred",

    "futures.validation.partial_close_size_required":
      "Size is required for partial close",
    "futures.validation.partial_close_size_min": "Size must be > 0",
    "futures.validation.partial_close_size_max": "Max size is",
    "futures.validation.must_be_gt_entry_price": "must be > entry price",
    "futures.validation.must_be_lt_entry_price": "must be < entry price",
  },

  ru: {
    "error.email_format": "* Неверный e-mail формат",
    "error.invalid_code": "* Неверный код. Пожалуйста, попробуйте еще раз",
    "error.invalid_code_format": "* Неверный формат кода",
    "error.pass_required": "* Требуется пароль",
    "error.incorrect_email": "Неверный e-mail адрес",
    "error.pass_different": "*Пароли не совпадают",
    "error.max": "*Сумма превышает допустимый лимит",
    "error.min": "*Сумма слишком мала.",
    "error.file_too_large": "Размер файла должен быть менее 2МБ",
    "error.avatar_too_large_hint":
      "Изображение слишком большое. Загрузите файл меньшего размера (например, до 1–2 МБ).",
    "error.invalid_file_type": "Пожалуйста, выберите файл изображения",
    "error.upload_failed": "Не удалось загрузить аватар",
    "error.select_payment_method": "* Выберите метод оплаты",
    "common.error_occurred": "Произошла ошибка",

    "futures.validation.partial_close_size_required":
      "Размер обязателен для частичного закрытия",
    "futures.validation.partial_close_size_min": "Размер должен быть > 0",
    "futures.validation.partial_close_size_max": "Макс. размер:",
    "futures.validation.must_be_gt_entry_price": "должно быть > цены входа",
    "futures.validation.must_be_lt_entry_price": "должно быть < цены входа",
  },

  es: {
    "error.email_format": "* Formato de correo electrónico inválido",
    "error.invalid_code": "* Código inválido. Por favor, inténtalo de nuevo",
    "error.invalid_code_format": "* Formato de código inválido",
    "error.pass_required": "* Contraseña requerida",
    "error.incorrect_email": "Dirección de correo electrónico incorrecta",
    "error.invalid": "Dirección de correo electrónico incorrecta",
    "error.pass_different": "* Las contraseñas no coinciden",
    "error.max": "*La cantidad supera el límite permitido",
    "error.min": "*La cantidad es demasiado baja",
    "error.file_too_large": "El tamaño del archivo debe ser menor a 2MB",
    "error.avatar_too_large_hint":
      "La imagen es demasiado grande. Sube un archivo más pequeño (por ejemplo, hasta 1–2MB).",
    "error.invalid_file_type": "Por favor, selecciona un archivo de imagen",
    "error.upload_failed": "Error al cargar el avatar",
    "error.select_payment_method": "* Selecciona un método de pago",
    "common.error_occurred": "Ocurrió un error",

    "futures.validation.partial_close_size_required":
      "El tamaño es obligatorio para el cierre parcial",
    "futures.validation.partial_close_size_min": "El tamaño debe ser > 0",
    "futures.validation.partial_close_size_max": "El tamaño máximo es",
    "futures.validation.must_be_gt_entry_price": "debe ser > precio de entrada",
    "futures.validation.must_be_lt_entry_price": "debe ser < precio de entrada",
  },

  ua: {
    "error.email_format": "* Невірний формат електронної пошти",
    "error.invalid_code": "*Невірний код. Спробуйте ще раз",
    "error.invalid_code_format": "* Невірний формат коду",
    "error.pass_required": "*Пароль обов’язковий",
    "error.incorrect_email": "Невірна електронна адреса",
    "error.invalid": "Невірна електронна адреса",
    "error.pass_different": "*Паролі не збігаються",
    "error.max": "*Сума перевищує дозволений ліміт",
    "error.min": "*Сума занадто мала",
    "error.file_too_large": "Розмір файлу повинен бути менше 2МБ",
    "error.avatar_too_large_hint":
      "Зображення завелике. Спробуйте менше (наприклад до 1–2MB).",
    "error.invalid_file_type": "Будь ласка, виберіть файл зображення",
    "error.upload_failed": "Не вдалося завантажити аватар",
    "error.select_payment_method": "* Оберіть метод оплати",
    "common.error_occurred": "Сталася помилка",

    "futures.validation.partial_close_size_required":
      "Розмір є обов’язковим для часткового закриття",
    "futures.validation.partial_close_size_min": "Розмір має бути > 0",
    "futures.validation.partial_close_size_max": "Макс. розмір:",
    "futures.validation.must_be_gt_entry_price": "має бути > ціни входу",
    "futures.validation.must_be_lt_entry_price": "має бути < ціни входу",
  },
};

export default error;
